// extracted by mini-css-extract-plugin
module.exports = {"btn":"SyncButton_btn__1Ud_F","refresh":"SyncButton_refresh__2yOW0"};